import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import VirtualDesktopCalc from '../components/calculators/VirtualDesktopCalc'
import { Breadcrumbs } from '../components/shared/Breadcrumbs'
import { generateBreadcrumbList } from '../utils/schemaHelpers'

export default function VirtualDesktopPage() {
  return (
    <>
      <Helmet>
        <title>Azure Virtual Desktop Cost Calculator UK | AzureCalc.uk</title>
        <meta name="description" content="Calculate Azure Virtual Desktop (AVD) costs for UK South — session hosts, FSLogix profile storage, per-user licensing, and networking. Free independent estimator." />
        <link rel="canonical" href="https://www.azure-calc.co.uk/virtual-desktop" />
        <meta property="og:title" content="Azure Virtual Desktop Cost Calculator UK" />
        <meta property="og:description" content="Free independent AVD pricing calculator for UK South. Session hosts, FSLogix storage, user licensing, Windows 365 comparison." />
        <meta property="og:url" content="https://www.azure-calc.co.uk/virtual-desktop" />
        <meta property="og:image" content="https://www.azure-calc.co.uk/og/azure-calc-og.png" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">{JSON.stringify(generateBreadcrumbList([
          { name: 'Home', url: '/', position: 1 },
          { name: 'Azure Virtual Desktop Calculator', url: '/virtual-desktop', position: 2 },
        ]))}</script>
        <script type="application/ld+json">{JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebApplication',
          name: 'Azure Virtual Desktop Cost Calculator',
          description: 'Independent Azure Virtual Desktop pricing calculator for UK South — session hosts, FSLogix, per-user licensing',
          url: 'https://www.azure-calc.co.uk/virtual-desktop',
          applicationCategory: 'FinanceApplication',
          operatingSystem: 'Web',
          offers: { '@type': 'Offer', price: '0', priceCurrency: 'GBP' },
        })}</script>
      </Helmet>

      <div className="px-6 py-6 w-full">
        <div className="pb-6 mb-8" style={{ borderBottom: '1px solid var(--outline-variant)' }}>
          <Breadcrumbs />
          <h1 className="text-2xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
            Azure Virtual Desktop Cost Calculator
          </h1>
          <p className="text-sm" style={{ color: 'var(--text-tertiary)' }}>
            UK South pricing · Session hosts · FSLogix profiles · Per-user licensing · Networking
          </p>
        </div>

        <VirtualDesktopCalc />

        <div className="mt-12 pt-8" style={{ borderTop: '1px solid var(--outline-variant)' }}>
          <h2 className="text-[13px] font-bold uppercase tracking-widest mb-4" style={{ color: 'var(--text-tertiary)' }}>Related guides</h2>
          <Link
            to="/guides/azure-virtual-desktop-pricing-uk"
            className="flex items-center gap-3 p-4 rounded transition-colors group"
            style={{ backgroundColor: 'var(--surface-container)', border: '1px solid var(--outline-variant)' }}
          >
            <span className="material-symbols-outlined text-[#0078d4] text-[20px]" style={{ fontVariationSettings: "'FILL' 1" }}>menu_book</span>
            <div>
              <p className="text-[14px] font-semibold group-hover:text-[#0078d4] transition-colors" style={{ color: 'var(--text-secondary)' }}>Azure Virtual Desktop Pricing Guide UK</p>
              <p className="text-[12px]" style={{ color: 'var(--text-tertiary)' }}>FSLogix Standard vs Premium trap, session host sizing, per-user licensing explained</p>
            </div>
            <span className="material-symbols-outlined text-[#0078d4] text-[16px] ml-auto">arrow_forward</span>
          </Link>
        </div>
      </div>
    </>
  )
}
